import type { RouteLocationRaw, RouteParams } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";

import SUvLerngruppen from "~/components/unterrichtsverteilung/lerngruppen/SUvLerngruppen.vue";
import SUvLerngruppenAuswahl from "~/components/unterrichtsverteilung/lerngruppen/SUvLerngruppenAuswahl.vue";
import { RouteUv } from "~/router/apps/unterrichtsverteilung/RouteUv";
import { RouteNode } from "~/router/RouteNode";
import { schuleStateImpl as schuleState } from "~/states/SchuleStateImpl";
import { uvStateImpl } from '~/states/UvStateImpl';

import { RouteDataUvLerngruppen } from "./RouteDataUvLerngruppen";

export class RouteUvLerngruppen extends RouteNode<RouteDataUvLerngruppen, RouteUv> {

	public constructor() {
		super(Schulform.values(), [BenutzerKompetenz.UNTERRICHTSVERTEILUNG_ANSEHEN], "uv.lerngruppen", String.raw`lerngruppen/:idLerngruppe(\d+)?`, SUvLerngruppen, new RouteDataUvLerngruppen());
		super.mode = ServerMode.DEV;
		super.propHandler = () => this.getProps();
		super.text = "Lerngruppen";
		this.isHidden = (params?: RouteParams) => RouteUv.tabsCheckHidden(false, true, params);
		super.setView("auswahl", SUvLerngruppenAuswahl, () => this.getAuswahlProps());
	}

	protected async update(to: RouteNode<any, any>, to_params: RouteParams, from: RouteNode<any, any> | undefined,
		from_params: RouteParams, isEntering: boolean, redirected: RouteNode<any, any> | undefined): Promise<void | Error | RouteLocationRaw> {
		const plan = uvStateImpl.planungsabschnitt;
		const items = plan === null || plan.id === -1 ? [] : uvStateImpl.uvManager.lerngruppeGetMengeByPlanungsabschnitt(plan);
		this.data.setAuswahlFromRoute(RouteUv.resolveAuswahl(to_params.idLerngruppe, items, item => item.id));
		return super.update(to, to_params, from, from_params, isEntering, redirected);
	}

	public getAuswahlProps() {
		return {
			auswahl: this.data.auswahl,
			gotoLerngruppe: this.data.gotoLerngruppe,
		};
	}

	public getProps() {
		return {
			lerngruppe: this.data.auswahl,
			schuljahr: schuleState.abschnitt.schuljahr,
			gotoKurs: this.data.gotoKurs,
			gotoKlasse: this.data.gotoKlasse,
			gotoLehrer: this.data.gotoLehrer,
			gotoSchiene: this.data.gotoSchiene,
		};
	}

}

export const routeUvLerngruppen = new RouteUvLerngruppen();
